import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { NgModule, Optional, SkipSelf } from '@angular/core';
import { ViewModel } from '../services/user/view.model';
import { BackendAPIService } from './backend-api.service';
import { BackendAPIHttpInterceptor } from './http-interceptor';

@NgModule({
    imports: [
        HttpClientModule
    ],
    declarations: [
    ],
    exports: [
    ],
    providers: [
        BackendAPIService,
        ViewModel,

        // Register an Angular provider whose value is the "upgraded" angularJS service
        // {provide: 'titleCase', useFactory: (i: any) => i.get('titleCase'), deps: ['$injector']}
        {
            provide: HTTP_INTERCEPTORS,
            useClass: BackendAPIHttpInterceptor, // TODO: Rename to AuthInterceptor and split stuff for making API calls
            multi: true
        }
    ]
})
export class CoreModule {
    constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
        if (parentModule) {
            throw new Error(
                'Core is already loaded. Import it in the AppModule only');
        }
    }

}
